export default __webpack_public_path__ + "static/media/Sansita-ExtraBoldItalic.d4d5aad8.ttf";